import * as React from "react";
import { render } from "react-dom";
import { AddGiftToCartButton } from "./AddGiftToCartButton";
import FindInStore from "./FindInStore";
import { LiquidAccount } from "../../types";
import * as Loyalty from "@dotdev/reactive-rewards";

const ProductTemplate: React.FC<IProps> = ({ variant, giftId }) => {
  const [account, setAccount] = React.useState<LiquidAccount>(null);
  React.useEffect(() => {
    (async () => {
      const res = await fetch(`/account?view=json`);
      const text = await res.text();
      const json = JSON.parse(text.replace(/(<([^>]+)>)/gi, ""));
      setAccount(json);
    })();
  }, []);

  return account ? (
    <Loyalty.Provider
      customer={account.customer}
      rewardId={window.theme.rewardId}
      url={window.theme.loyaltyUrl}
      storefront={{
        key: window.theme.storeFrontKey,
        url: window.theme.permanentDomain,
      }}
    >
      <AddGiftToCartButton variant={variant} giftId={giftId} />
    </Loyalty.Provider>
  ) : null;
};

window.addEventListener("load", () => {
  const buttonContainer = document.getElementById("ButtonContainer");
  const urlParams = new URLSearchParams(window.location.search);
  const giftParam = urlParams.get("gift");

  if (buttonContainer && giftParam) {
    const { product, selected_variant_id } = JSON.parse(
      document.querySelector("[data-product-json]").innerHTML
    );
    const sel = product.variants.find((v: any) => v.id === selected_variant_id);
    const variant = {
      availableForSale: sel.available,
      id: sel.id,
      price: sel.price,
      title: sel.title,
      options: product.options.map((opt: string, i: number) => ({
        name: opt,
        value: sel.options[i],
      })),
    };
    render(
      <ProductTemplate variant={variant} giftId={giftParam} />,
      buttonContainer
    );
  }

  const findInStore = document.getElementById("findInStoreModal");

  if (findInStore) {
    const { product, selected_variant_id } = JSON.parse(
      document.querySelector("[data-product-json]").innerHTML
    );
    const sel = product.variants.find((v: any) => v.id === selected_variant_id);
    const variant = {
      availableForSale: sel.available,
      id: sel.id,
      price: sel.price,
      title: sel.title,
      options: product.options.map((opt: string, i: number) => ({
        name: opt,
        value: sel.options[i],
      })),
    };
    render(
      <FindInStore variant={variant} stores={window.theme.stores} />,
      findInStore
    );
  }

  const mutationObserver = new MutationObserver((mutationsList) => {
    mutationsList.forEach((mutation: any) => {
      if (mutation.attributeName === "class") {
        if (mutation.target.className.includes("--video")) {
          const id = mutation.target.dataset.imageId;
          const slide = document.querySelector(`#Image${id}`);
          if (mutation.target.className.includes("is-selected")) {
            slide.querySelector("video").play();
          } else {
            slide.querySelector("video").pause();
          }
        }
      }
    });
  });

  document.querySelectorAll("[data-image-id").forEach((elem) => {
    mutationObserver.observe(elem, { attributes: true });
  });
});

interface IProps {
  variant: {
    id: number;
    availableForSale: boolean;
    price: number;
    title: string;
    options: {
      name: string;
      value: string;
    }[];
  };
  giftId: string;
}
